import React, { useState, useCallback, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import Grid from '@material-ui/core/Grid';

import { connect } from "react-redux";

import { Wrapper, WrapperPartners, Partners, WrappLoadMore } from "./styles";
import { Container } from "../../../components/design/layout/container";
import { Headline } from "../../../components/design/foundation/headline";
import ButtonSelectState from "../../../components/patterns/button-select-state";
import PartnerBox from "../../../components/design/layout/partner-box";
import Button from "../../../components/design/form/button"

import PartnerService from '../../../services/Partner';

import loadImage from "../../../utils/LoadImage";
import PartnerLoader from "../../../components/design/layout/loader/partner";

function ListPartners({ website }) {
    const [partners, setPartners] = useState([]);
    const [limit, setLimit] = useState(8);

    // * Loading States
    const [isLoading, setIsLoading] = useState(true);

    const searchPartners = (({ limit, search, categotyList, tag }) => {
        const partnerService = new PartnerService();

        partnerService.listBySearch({
            limit: limit,
            search: search,
            categoryList: categotyList,
            tag: tag
        }).then((response) => {
            setPartners(response.data.payload);

            if (response.data.payload) {
                setIsLoading(status => status = false);
            }

        }).catch(err => {
            Swal.fire({
                icon: "error",
                html: err.message,
                title: "",
            });
        });
    });

    const loadMore = () => {
        const newLimit = limit + 8;
        setLimit(newLimit);

        searchPartners({ limit: newLimit })
    }

    const handleInitialListPartners = useCallback(() => {
        searchPartners({ limit: limit });
    }, [limit]);

    useEffect(() => {
        handleInitialListPartners();
    }, [handleInitialListPartners]);

    return (
        <Wrapper>
            <ButtonSelectState theme={website} title="Informe seu estado" link="/lista-estados" />
            <Container withContainer={true} className="ContainerBottom">
                <WrapperPartners>
                    <Partners>
                        <Headline
                            type="medium"
                            title="Parceiros"
                            subTitle="Confira abaixo todas as lojas"
                            withLink={false}
                            linkText="Ver mais"
                            link="#!"
                            textAlign="left"
                        />

                        {isLoading && (<Grid container spacing={0}>
                            {[0, 1, 2, 3].map((item, i) =>
                                <Grid key={`${item}-${i}`} item xs={12}>
                                    <PartnerLoader />
                                </Grid>
                            )}
                        </Grid>)}

                        <Grid container spacing={0}>
                            {partners && partners.map((item, i) => (
                                <Grid key={`${item.nome}-${i}`} item xs={12}>
                                    <PartnerBox
                                        title={item.nome}
                                        cover={loadImage({ imageCode: item.imagem_banner })}
                                        partnerLogo={loadImage({ imageCode: item.imagem_avatar })}
                                        partnerId={item._id}
                                        partnerUrl={item.website}
                                    />
                                </Grid>
                            ))}
                        </Grid>

                        <WrappLoadMore>
                            {limit <= partners.length && (
                                <Button
                                    styleType="bordered"
                                    buttonSize="small"
                                    buttonColor={props => props.theme[this.props.website]?.button.background}
                                    textColor={props => props.theme[this.props.website]?.button.color}
                                    borderColor={props => props.theme[this.props.website]?.button.background}
                                    buttonText="Mostrar mais parceiros"
                                    maxWidth={200}
                                    onClick={() => loadMore()}
                                />
                            )}
                        </WrappLoadMore>
                    </Partners>
                </WrapperPartners>
            </Container>
        </Wrapper>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(ListPartners));